import { render } from "./Pinball.vue?vue&type=template&id=49d13958&bindings={}"
import script from "./Pinball.vue?vue&type=script&lang=ts"
export * from "./Pinball.vue?vue&type=script&lang=ts"
script.render = render

export default script